// import {
//    Button,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalFooter,
//    ModalBody,
//    ModalCloseButton,
//    useColorModeValue,
//    Grid,
//    GridItem,
// } from '@chakra-ui/react';
// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { getBrand } from '../../../../redux/actions/brand';
// import { getCategory } from '../../../../redux/actions/category';
// import { getSeries } from '../../../../redux/actions/series';
// import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
// import { RAM_TYPE, STORAGE_TYPE } from '../../../../variables/company';
// import { getColor } from '../../../../redux/actions/color';
// import {
//    getbalanceSheetVertical,
//    getReportLedger,
//    getReportStockDetail,
//    getTrialBalance,
//    getTrialBalanceFull,
//    getTrialBalanceGLGroupWise,
// } from '../../../../redux/actions/reports';
// import { useUser } from 'contexts';
// import { getDaybook } from '../../../../redux/actions/daybook';
// import { getAccount } from '../../../../redux/actions/account';
// import { getItems } from '../../../../redux/actions/item';
// import { getGLGroups } from '../../../../redux/actions/glGroup';
// import { useGlobal } from 'contexts';
// import MultiSelectDropdown from 'components/ui/MultiSelectDropdown';
// import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';

// function StockFilter({ isOpen, onClose, companyIds, fromDate, toDate, accountId, entityType, subEntityType }) {
//    const { user } = useUser();
//    const { userGlobalSettingsData } = useGlobal();
//    const dispatch = useDispatch();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const isColorMode = useColorModeValue(true, false);
//    const brandData = useSelector((state) => state.brand.list || []);
//    const categoryData = useSelector((state) => state.category.list || []);
//    const seriesData = useSelector((state) => state.series.list || []);
//    const colorData = useSelector((state) => state.color.list || []);
//    const accountData = useSelector((state) => state.account.list || []);
//    const itemData = useSelector((state) => state.item.data || []);
//    const getGLGroupsList = useSelector((state) => state.glGroup.list);
//    const daybookData = useSelector((state) => state.daybook.list || []);
//    const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
//    const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
//    const globalSettingDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook;
//    const shouldShowCompanyDropdownDaybook = globalSettingDaybook || false;
//    const globalSettingItem = userGlobalSettingsData?.[0]?.askCompany?.item;
//    const shouldShowCompanyDropdownItem = globalSettingItem || false;
//    const globalSettingBrand = userGlobalSettingsData?.[0]?.askCompany?.brand;
//    const shouldShowCompanyDropdownBrand = globalSettingBrand || false;
//    const globalSettingCategory = userGlobalSettingsData?.[0]?.askCompany?.category;
//    const shouldShowCompanyDropdownCategory = globalSettingCategory || false;
//    const globalSettingSeries = userGlobalSettingsData?.[0]?.askCompany?.series;
//    const shouldShowCompanyDropdownSeries = globalSettingSeries || false;
//    const globalSettingColor = userGlobalSettingsData?.[0]?.askCompany?.color;
//    const shouldShowCompanyDropdownColor = globalSettingColor || false;
//    useEffect(() => {
//       if (isOpen) {
//          dispatch(
//             getBrand({
//                ...(shouldShowCompanyDropdownBrand &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getCategory({
//                ...(shouldShowCompanyDropdownCategory &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getSeries({
//                ...(shouldShowCompanyDropdownSeries &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getColor({
//                ...(shouldShowCompanyDropdownColor &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(getGLGroups());
//          dispatch(
//             getItems({
//                companyId: user?.loginhistory?.companyId,
//                ...(shouldShowCompanyDropdownItem &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//                status: true,
//             }),
//          );
//          dispatch(
//             getAccount({
//                compId: user?.loginhistory?.companyId,
//                ...(shouldShowCompanyDropdownAcc &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getDaybook({
//                companyId: user?.loginhistory?.companyId,
//                ...(shouldShowCompanyDropdownDaybook &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//       }
//    }, [
//       dispatch,
//       isOpen,
//       user,
//       shouldShowCompanyDropdownSeries,
//       shouldShowCompanyDropdownBrand,
//       shouldShowCompanyDropdownItem,
//       shouldShowCompanyDropdownColor,
//       shouldShowCompanyDropdownAcc,
//       shouldShowCompanyDropdownDaybook,
//       shouldShowCompanyDropdownCategory,
//       companyIds,
//    ]);

//    const initialFormData = {
//       colorIds: [],
//       ram: '',
//       seriesIds: [],
//       categoryIds: [],
//       brandIds: [],
//       storage: '',
//       accountIds: [],
//       itemIds: [],
//       daybookIds: [],
//       glGroupId: [],
//    };

//    const [formData, setFormData] = useState(initialFormData);

//    const handleBrandChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
//    };

//    const handleCategoryChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
//    };

//    const handleSeriesChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
//    };

//    const handleColorChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, colorIds: selectedValues || [] }));
//    };

//    const handleAccountChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, accountIds: selectedValues || [] }));
//    };

//    const handleUserTypeChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, glGroupId: selectedValues || [] }));
//    };

//    const handleItemChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, itemIds: selectedValues || [] }));
//    };

//    const handleDaybookChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, daybookIds: selectedValues || [] }));
//    };

//    const handleInputChange = (name, value) => {
//       setFormData((prev) => ({
//          ...prev,
//          [name]: value,
//       }));
//    };

//    // Helper function to check if a value has content
//    const hasValue = (value) => {
//       if (Array.isArray(value)) {
//          return value.length > 0;
//       }
//       return value !== '' && value !== null && value !== undefined;
//    };

//    const handleSubmit = (e) => {
//       e.preventDefault();

//       // Base payload with required fields
//       const payload = {
//          companyIds: companyIds.toString(),
//          fromDate: fromDate,
//          toDate: toDate,
//          ...(entityType?.toLowerCase() === 'statement' && { orderBy: 'desc' }),
//          ...(entityType?.toLowerCase() === 'statement' && { accIds: accountId }),
//       };

//       // Only add fields that have values
//       // if (hasValue(formData.colorIds)) {
//       //    payload.colorIds = formData.colorIds.toString();
//       // }

//       // if (hasValue(formData.ram)) {
//       //    payload.rams = formData.ram.toString();
//       // }

//       // if (hasValue(formData.seriesIds)) {
//       //    payload.seriesIds = formData.seriesIds.toString();
//       // }

//       // if (hasValue(formData.categoryIds)) {
//       //    payload.categoryIds = formData.categoryIds.toString();
//       // }

//       // if (hasValue(formData.brandIds)) {
//       //    payload.brandIds = formData.brandIds.toString();
//       // }

//       // if (hasValue(formData.storage)) {
//       //    payload.storages = formData.storage.toString();
//       // }

//       if (hasValue(formData.glGroupId)) {
//          if (entityType === 'Balance Sheet') {
//             payload.glIds = formData.glGroupId.toString();
//          }
//          if (subEntityType === 'Trail Balance Account' || subEntityType === 'Trail Balance Vertical') {
//             payload.glIds = formData.glGroupId.toString();
//          }
//          if (subEntityType === 'Trail Balance T Format') {
//             payload.glIds = formData.glGroupId.toString();
//          }
//          if (subEntityType === 'Trail Balance GL Group') {
//             payload.glIds = formData.glGroupId.toString();
//          }
//       }

//       if (hasValue(formData.accountIds)) {
//          if (entityType === 'Balance Sheet') {
//             payload.accIds = formData.accountIds.toString();
//          }
//          if (entityType === 'statement') {
//             payload.contraAccIds = formData.accountIds.toString();
//          }
//          if (subEntityType === 'Trail Balance Account' || subEntityType === 'Trail Balance Vertical') {
//             payload.accIds = formData.accountIds.toString();
//          }
//          if (subEntityType === 'Trail Balance T Format') {
//             payload.accIds = formData.accountIds.toString();
//          }
//       }

//       // if (hasValue(formData.itemIds)) {
//       //    payload.itemIds = formData.itemIds.toString();
//       // }

//       if (hasValue(formData.daybookIds)) {
//          payload.daybookIds = formData.daybookIds.toString();
//       }

//       if (entityType === 'statement') {
//          dispatch(getReportLedger(payload));
//       }
//       if (entityType === 'Balance Sheet') {
//          dispatch(getbalanceSheetVertical(payload));
//       }
//       if (subEntityType === 'Trail Balance Account' || subEntityType === 'Trail Balance Vertical') {
//          dispatch(getTrialBalance(payload));
//       }
//       if (subEntityType === 'Trail Balance T Format') {
//          dispatch(getTrialBalanceFull(payload));
//       }
//       if (subEntityType === 'Trail Balance GL Group') {
//          dispatch(getTrialBalanceGLGroupWise(payload));
//       }
//       onClose();
//    };

//    const handleClear = () => {
//       // Reset all form fields to initial state
//       setFormData(initialFormData);

//       // Create payload with only required fields (no filters)
//       const payload = {
//          companyIds: companyIds.toString(),
//          fromDate: fromDate,
//          toDate: toDate,
//          accIds: accountId,
//       };

//       // Dispatch with cleared filters
//       dispatch(getReportStockDetail(payload));
//    };

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} size="xl">
//          <ModalOverlay />
//          <ModalContent as="form" onSubmit={handleSubmit}>
//             <ModalHeader>Stock Filter</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody pb={6}>
//                <Grid templateColumns="repeat(2, 1fr)" gap={4}>
//                   {(entityType?.toLowerCase()?.includes('statement') ||
//                      entityType?.toLowerCase()?.includes('balance sheet') ||
//                      subEntityType?.includes('Trail Balance Account') ||
//                      subEntityType?.includes('Trail Balance Vertical') ||
//                      subEntityType?.includes('Trail Balance T Format')) && (
//                         <GridItem>
//                            {/* {renderDynamicDropdown(
//                            'accountid',
//                            'Account',
//                            accountData,
//                            {
//                               value: formData.accountIds,
//                               onChange: handleAccountChange,
//                               showCustomNoOptions: true,
//                               openfrom: 'account',
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select Account',
//                            true,
//                            undefined,
//                            true,
//                         )} */}
//                            <MultiSelectDropdown
//                               label="Account"
//                               options={accountData}
//                               value={formData.accountIds}
//                               onChange={handleAccountChange}
//                               placeholder="Select Account"
//                               isRequired={true}
//                               showAddButton={true}
//                               onAddNew={(value) => console.log("handleAddNew", value)}
//                               isLoading={false}
//                               darkMode={!isColorMode}
//                               AddEditFormComponent={AddEditForm}
//                               error={""}
//                            />
//                         </GridItem>
//                      )}
//                   {(entityType?.toLowerCase()?.includes('balance sheet') ||
//                      subEntityType?.includes('Trail Balance Account') ||
//                      subEntityType?.includes('Trail Balance Vertical') ||
//                      subEntityType?.includes('Trail Balance T Format') ||
//                      subEntityType?.includes('Trail Balance GL Group')) && (
//                         <GridItem>
//                            {renderDynamicDropdown(
//                               'glGroupId',
//                               'GL Group',
//                               getGLGroupsList,
//                               {
//                                  value: formData.glGroupId,
//                                  onChange: handleUserTypeChange,
//                                  showCustomNoOptions: true,
//                                  openfrom: 'account',
//                               },
//                               {},
//                               textColor,
//                               false,
//                               'Select User Type',
//                               true,
//                               undefined,
//                               true,
//                            )}
//                         </GridItem>
//                      )}
//                   {/* Daybook Dropdown */}
//                   {entityType?.toLowerCase()?.includes('statement') && (
//                      <GridItem>
//                         {renderDynamicDropdown(
//                            'daybookid',
//                            'Daybook',
//                            daybookData,
//                            {
//                               value: formData.daybookIds,
//                               onChange: handleDaybookChange,
//                               showCustomNoOptions: true,
//                               openfrom: 'daybook',
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select Daybook',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   )}
//                   {/* <GridItem>
//                      {renderDynamicDropdown(
//                         'itemid',
//                         'Item',
//                         itemData,
//                         {
//                            value: formData.itemIds,
//                            onChange: handleItemChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'item',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Item',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem> */}
//                   {/* Brand Dropdown */}
//                   {/* <GridItem>
//                      {renderDynamicDropdown(
//                         'brandid',
//                         'Brand',
//                         brandData,
//                         {
//                            value: formData.brandIds,
//                            onChange: handleBrandChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'brand',
//                         },
//                         {},
//                         textColor,
//                         true,
//                         'Select Brand',
//                         false,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem> */}

//                   {/* Category Dropdown */}
//                   {/* <GridItem>
//                      {renderDynamicDropdown(
//                         'categoryid',
//                         'Category',
//                         categoryData,
//                         {
//                            value: formData.categoryIds,
//                            onChange: handleCategoryChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'category',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Category',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem> */}

//                   {/* Series Dropdown */}
//                   {/* <GridItem>
//                      {renderDynamicDropdown(
//                         'seriesId',
//                         'Series',
//                         seriesData,
//                         {
//                            value: formData.seriesIds,
//                            onChange: handleSeriesChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'series',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Series',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem> */}

//                   {/* Color Dropdown */}
//                   {/* <GridItem>
//                      {renderDynamicDropdown(
//                         'colorId',
//                         'Color',
//                         colorData,
//                         {
//                            value: formData.colorIds,
//                            onChange: handleColorChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'color',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Color',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem> */}

//                   {/* RAM Dropdown */}
//                   {/* <GridItem>
//                      {renderDynamicDropdown(
//                         'ramId',
//                         'RAM',
//                         RAM_TYPE,
//                         {
//                            value: formData.ram,
//                            onChange: (value) => handleInputChange('ram', value),
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select RAM',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem> */}

//                   {/* Storage Dropdown */}
//                   {/* <GridItem>
//                      {renderDynamicDropdown(
//                         'storageId',
//                         'Storage',
//                         STORAGE_TYPE,
//                         {
//                            value: formData.storage,
//                            onChange: (value) => handleInputChange('storage', value),
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Storage',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem> */}
//                </Grid>
//             </ModalBody>

//             <ModalFooter>
//                <Button type="submit" colorScheme="green" mr={3}>
//                   Apply Filters
//                </Button>
//                <Button onClick={handleClear}>Reset</Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// }

// export default StockFilter;

import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   useColorMode,
   Grid,
   GridItem,
   Box,
   Text,
   Divider,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBrand } from '../../../../redux/actions/brand';
import { getCategory } from '../../../../redux/actions/category';
import { getSeries } from '../../../../redux/actions/series';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { RAM_TYPE, STORAGE_TYPE } from '../../../../variables/company';
import { getColor } from '../../../../redux/actions/color';
import {
   getbalanceSheetVertical,
   getReportLedger,
   getReportStockDetail,
   getTrialBalance,
   getTrialBalanceFull,
   getTrialBalanceGLGroupWise,
} from '../../../../redux/actions/reports';
import { useUser } from 'contexts';
import { getDaybook } from '../../../../redux/actions/daybook';
import { getAccountForReport } from '../../../../redux/actions/account';
import { getItems } from '../../../../redux/actions/item';
import { getGLGroups } from '../../../../redux/actions/glGroup';
import { useGlobal } from 'contexts';
import MultiSelectDropdown from 'components/ui/MultiSelectDropdown';
import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';
import DaybookForm from '../../masters/Pages/DaybookMaster/DaybookForm';
import LedgerMasterForm from '../../masters/Pages/LedgerMaster/LedgerMasterForm';

function StockFilter({ isOpen, onClose, companyIds, fromDate, toDate, accountId, entityType, subEntityType }) {
   const { user } = useUser();
   const { userGlobalSettingsData } = useGlobal();
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const textColor = isDark ? 'white' : '#9E9E9E';
   const isColorMode = !isDark;

   const brandData = useSelector((state) => state.brand.list || []);
   const categoryData = useSelector((state) => state.category.list || []);
   const seriesData = useSelector((state) => state.series.list || []);
   const colorData = useSelector((state) => state.color.list || []);
   const accountData = useSelector((state) => state.account.listForReport || []);
   const itemData = useSelector((state) => state.item.data || []);
   const getGLGroupsList = useSelector((state) => state.glGroup.list);
   const daybookData = useSelector((state) => state.daybook.list || []);
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
   const globalSettingDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook;
   const shouldShowCompanyDropdownDaybook = globalSettingDaybook || false;
   const globalSettingItem = userGlobalSettingsData?.[0]?.askCompany?.item;
   const shouldShowCompanyDropdownItem = globalSettingItem || false;
   const globalSettingBrand = userGlobalSettingsData?.[0]?.askCompany?.brand;
   const shouldShowCompanyDropdownBrand = globalSettingBrand || false;
   const globalSettingCategory = userGlobalSettingsData?.[0]?.askCompany?.category;
   const shouldShowCompanyDropdownCategory = globalSettingCategory || false;
   const globalSettingSeries = userGlobalSettingsData?.[0]?.askCompany?.series;
   const shouldShowCompanyDropdownSeries = globalSettingSeries || false;
   const globalSettingColor = userGlobalSettingsData?.[0]?.askCompany?.color;
   const shouldShowCompanyDropdownColor = globalSettingColor || false;

   useEffect(() => {
      if (isOpen) {
         dispatch(
            getBrand({
               ...(shouldShowCompanyDropdownBrand &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getCategory({
               ...(shouldShowCompanyDropdownCategory &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getSeries({
               ...(shouldShowCompanyDropdownSeries &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getColor({
               ...(shouldShowCompanyDropdownColor &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(getGLGroups());
         dispatch(
            getItems({
               companyId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdownItem &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
               status: true,
            }),
         );
         dispatch(
            getAccountForReport({
               compId: user?.loginhistory?.companyId,
               status: true,
               ...(shouldShowCompanyDropdownAcc &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getDaybook({
               companyId: user?.loginhistory?.companyId,
               ...(shouldShowCompanyDropdownDaybook &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
      }
   }, [
      dispatch,
      isOpen,
      user,
      shouldShowCompanyDropdownSeries,
      shouldShowCompanyDropdownBrand,
      shouldShowCompanyDropdownItem,
      shouldShowCompanyDropdownColor,
      shouldShowCompanyDropdownAcc,
      shouldShowCompanyDropdownDaybook,
      shouldShowCompanyDropdownCategory,
      companyIds,
   ]);

   const initialFormData = {
      colorIds: [],
      ram: '',
      seriesIds: [],
      categoryIds: [],
      brandIds: [],
      storage: '',
      accountIds: [],
      itemIds: [],
      daybookIds: [],
      glGroupId: [],
   };

   const [formData, setFormData] = useState(initialFormData);

   const handleBrandChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
   };

   const handleCategoryChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
   };

   const handleSeriesChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
   };

   const handleColorChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, colorIds: selectedValues || [] }));
   };

   const handleAccountChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, accountIds: selectedValues || [] }));
   };

   const handleUserTypeChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, glGroupId: selectedValues || [] }));
   };

   const handleItemChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, itemIds: selectedValues || [] }));
   };

   const handleDaybookChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, daybookIds: selectedValues || [] }));
   };

   const handleInputChange = (name, value) => {
      setFormData((prev) => ({
         ...prev,
         [name]: value,
      }));
   };

   const hasValue = (value) => {
      if (Array.isArray(value)) {
         return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
   };

   const handleSubmit = (e) => {
      e.preventDefault();

      const payload = {
         companyIds: companyIds.toString(),
         fromDate: fromDate,
         toDate: toDate,
         ...(entityType?.toLowerCase() === 'statement' && { orderBy: 'desc' }),
         ...(entityType?.toLowerCase() === 'statement' && { accIds: accountId }),
      };

      if (hasValue(formData.glGroupId)) {
         if (entityType === 'Balance Sheet') {
            payload.glIds = formData.glGroupId.toString();
         }
         if (subEntityType === 'Trail Balance Account' || subEntityType === 'Trail Balance Vertical') {
            payload.glIds = formData.glGroupId.toString();
         }
         if (subEntityType === 'Trail Balance T Format') {
            payload.glIds = formData.glGroupId.toString();
         }
         if (subEntityType === 'Trail Balance GL Group') {
            payload.glIds = formData.glGroupId.toString();
         }
      }

      if (hasValue(formData.accountIds)) {
         if (entityType === 'Balance Sheet') {
            payload.accIds = formData.accountIds.toString();
         }
         if (entityType === 'statement') {
            payload.contraAccIds = formData.accountIds.toString();
         }
         if (subEntityType === 'Trail Balance Account' || subEntityType === 'Trail Balance Vertical') {
            payload.accIds = formData.accountIds.toString();
         }
         if (subEntityType === 'Trail Balance T Format') {
            payload.accIds = formData.accountIds.toString();
         }
      }

      if (hasValue(formData.daybookIds)) {
         payload.daybookIds = formData.daybookIds.toString();
      }

      if (entityType === 'statement') {
         dispatch(getReportLedger(payload));
      }
      if (entityType === 'Balance Sheet') {
         dispatch(getbalanceSheetVertical(payload));
      }
      if (subEntityType === 'Trail Balance Account' || subEntityType === 'Trail Balance Vertical') {
         dispatch(getTrialBalance(payload));
      }
      if (subEntityType === 'Trail Balance T Format') {
         dispatch(getTrialBalanceFull(payload));
      }
      if (subEntityType === 'Trail Balance GL Group') {
         dispatch(getTrialBalanceGLGroupWise(payload));
      }
      onClose();
   };

   const handleClear = () => {
      setFormData(initialFormData);

      const payload = {
         companyIds: companyIds.toString(),
         fromDate: fromDate,
         toDate: toDate,
         accIds: accountId,
      };

      dispatch(getReportStockDetail(payload));
   };

   const showAccountField =
      entityType?.toLowerCase()?.includes('statement') ||
      entityType?.toLowerCase()?.includes('balance sheet') ||
      subEntityType?.includes('Trail Balance Account') ||
      subEntityType?.includes('Trail Balance Vertical') ||
      subEntityType?.includes('Trail Balance T Format');

   const showGLGroupField =
      entityType?.toLowerCase()?.includes('balance sheet') ||
      subEntityType?.includes('Trail Balance Account') ||
      subEntityType?.includes('Trail Balance Vertical') ||
      subEntityType?.includes('Trail Balance T Format') ||
      subEntityType?.includes('Trail Balance GL Group');

   const showDaybookField = entityType?.toLowerCase()?.includes('statement');

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
         <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(8px)" />
         <ModalContent
            as="form"
            onSubmit={handleSubmit}
            className={`${isDark ? 'bg-gray-800' : 'bg-white'} shadow-2xl`}>
            <ModalHeader
               className={`${isDark
                  ? 'bg-gradient-to-r from-slate-700 to-slate-800 text-white border-b-2 border-slate-600'
                  : 'bg-gradient-to-r from-blue-50 to-indigo-50 text-gray-800 border-b-2 border-blue-200'
                  } px-8 py-6 rounded-t-md`}>
               <Text className="text-2xl font-bold tracking-tight">Advanced Filters</Text>
               <Text className={`text-sm font-normal mt-1 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                  Refine your financial reports with precision filters
               </Text>
            </ModalHeader>
            <ModalCloseButton
               className={`${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-800'
                  } mt-4 mr-4`}
            />

            <ModalBody className={`${isDark ? 'bg-gray-800' : 'bg-gray-50'} px-8 py-6`}>
               {/* Account & Financial Section */}
               {(showAccountField || showGLGroupField || showDaybookField) && (
                  <Box className="mb-6">
                     <Box
                        className={`${isDark
                           ? 'bg-gradient-to-r from-emerald-900/40 to-teal-900/40 border-l-4 border-emerald-500'
                           : 'bg-gradient-to-r from-emerald-50 to-teal-50 border-l-4 border-emerald-400'
                           } px-5 py-3 rounded-lg mb-4 shadow-sm`}>
                        <Text
                           className={`text-base font-bold ${isDark ? 'text-emerald-300' : 'text-emerald-700'
                              } tracking-wide`}>
                           📊 ACCOUNT & FINANCIAL FILTERS
                        </Text>
                     </Box>

                     <Grid
                        templateColumns={
                           showAccountField && showGLGroupField && showDaybookField
                              ? 'repeat(3, 1fr)'
                              : (showAccountField && showGLGroupField) ||
                                 (showAccountField && showDaybookField) ||
                                 (showGLGroupField && showDaybookField)
                                 ? 'repeat(2, 1fr)'
                                 : 'repeat(1, 1fr)'
                        }
                        gap={5}>
                        {showAccountField && (
                           <GridItem
                              className={`${isDark
                                 ? 'bg-gray-700/50 border border-gray-600 hover:border-emerald-500'
                                 : 'bg-white border border-gray-200 hover:border-emerald-400'
                                 } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                              <MultiSelectDropdown
                                 label="Account"
                                 options={accountData}
                                 value={formData.accountIds}
                                 onChange={handleAccountChange}
                                 placeholder="Select Account"
                                 isRequired={true}
                                 showAddButton={true}
                                 onAddNew={(value) => console.log('handleAddNew', value)}
                                 isLoading={false}
                                 darkMode={!isColorMode}
                                 AddEditFormComponent={AddEditForm}
                                 error={''}
                              />
                           </GridItem>
                        )}

                        {showGLGroupField && (
                           <GridItem
                              className={`${isDark
                                 ? 'bg-gray-700/50 border border-gray-600 hover:border-emerald-500'
                                 : 'bg-white border border-gray-200 hover:border-emerald-400'
                                 } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                              {/* {renderDynamicDropdown(
                                 'glGroupId',
                                 'GL Group',
                                 getGLGroupsList,
                                 {
                                    value: formData.glGroupId,
                                    onChange: handleUserTypeChange,
                                    showCustomNoOptions: true,
                                    openfrom: 'account',
                                 },
                                 {},
                                 textColor,
                                 false,
                                 'Select GL Group',
                                 true,
                                 undefined,
                                 true,
                              )} */}
                              <MultiSelectDropdown
                                 label="GL Group"
                                 options={getGLGroupsList}
                                 value={formData.glGroupId}
                                 onChange={handleUserTypeChange}
                                 placeholder="Select GL Group"
                                 isRequired={true}
                                 showAddButton={true}
                                 onAddNew={(value) => console.log('handleAddNew', value)}
                                 isLoading={false}
                                 darkMode={!isColorMode}
                                 AddEditFormComponent={LedgerMasterForm}
                                 error={''}
                              />
                           </GridItem>
                        )}

                        {showDaybookField && (
                           <GridItem
                              className={`${isDark
                                 ? 'bg-gray-700/50 border border-gray-600 hover:border-emerald-500'
                                 : 'bg-white border border-gray-200 hover:border-emerald-400'
                                 } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                              <MultiSelectDropdown
                                 label="Daybook"
                                 options={daybookData}
                                 value={formData.daybookIds}
                                 onChange={handleDaybookChange}
                                 placeholder="Select Daybook"
                                 isRequired={true}
                                 showAddButton={true}
                                 onAddNew={(value) => console.log('handleAddNew', value)}
                                 isLoading={false}
                                 darkMode={!isColorMode}
                                 AddEditFormComponent={DaybookForm}
                                 error={''}
                              />
                              {/* {renderDynamicDropdown(
                                 'daybookid',
                                 'Daybook',
                                 daybookData,
                                 {
                                    value: formData.daybookIds,
                                    onChange: handleDaybookChange,
                                    showCustomNoOptions: true,
                                    openfrom: 'daybook',
                                 },
                                 {},
                                 textColor,
                                 false,
                                 'Select Daybook',
                                 true,
                                 undefined,
                                 true,
                              )} */}
                           </GridItem>
                        )}
                     </Grid>
                  </Box>
               )}

               {/* Empty State Message */}
               {!showAccountField && !showGLGroupField && !showDaybookField && (
                  <Box
                     className={`${isDark
                        ? 'bg-gray-700/30 border-2 border-dashed border-gray-600'
                        : 'bg-blue-50/50 border-2 border-dashed border-blue-200'
                        } rounded-lg p-12 text-center`}>
                     <Text className={`text-lg font-semibold ${isDark ? 'text-gray-300' : 'text-gray-600'} mb-2`}>
                        🔍 No Filters Available
                     </Text>
                     <Text className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        No additional filters are applicable for the selected report type
                     </Text>
                  </Box>
               )}
            </ModalBody>

            <ModalFooter
               className={`${isDark ? 'bg-gray-800 border-t-2 border-gray-700' : 'bg-gray-50 border-t-2 border-gray-200'
                  } px-8 py-5 rounded-b-md`}>
               <Button
                  type="submit"
                  className={`${isDark
                     ? 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700'
                     : 'bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600'
                     } text-white font-semibold px-8 py-2 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 mr-3`}
                  colorScheme="green">
                  ✓ Apply Filters
               </Button>
               <Button
                  onClick={handleClear}
                  className={`${isDark
                     ? 'bg-gray-700 hover:bg-gray-600 text-gray-200 border border-gray-600'
                     : 'bg-white hover:bg-gray-100 text-gray-700 border border-gray-300'
                     } font-semibold px-8 py-2 rounded-lg shadow-md transition-all duration-300 transform hover:scale-105`}>
                  ↻ Reset
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
}

export default StockFilter;
